/**
 * Toggle Password Visibility Module
 *
 * Handles show/hide password functionality for password inputs
 */

export const initTogglePassword = () => {
	const toggleButtons = document.querySelectorAll('.toggle-password');

	if (!toggleButtons.length) {
		return;
	}

	toggleButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const input = button.previousElementSibling;
			const showIcon = button.querySelector('.show-icon');
			const hideIcon = button.querySelector('.hide-icon');

			if (input.type === 'password') {
				input.type = 'text';
				showIcon.classList.add('hidden');
				hideIcon.classList.remove('hidden');
			} else {
				input.type = 'password';
				showIcon.classList.remove('hidden');
				hideIcon.classList.add('hidden');
			}
		});
	});
};
